<template>
<div class="mt_140">

      <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
      <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

      <div class="container">
      <div class="row">
      <div class="col-md-12">

        <!-- row -->
        <div class="row">

          <!-- coluna 2 -->
          <div class="col-md-2">
            <ccMenuConta :num=8></ccMenuConta>
          </div">
          <!-- fim coluna 2 -->

          <!-- coluna 10 -->
          <div class="col-md-10 pt-0 pt-2 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                <ccContaConviteTopo v-bind:btn=1> </ccContaConviteTopo>

                <br>

                <div class="row">

                  <div class="col-md-4">
                      <div class="card">
                      <div class="card-body">
                        <div class="text_branco text_12 text_bold text-center pb-3">Ontem:</div>
                        <div class="col-12">
                          <div class="row">
                            <div class="col-4">
                              <div class="text_10 text_cinza text-center">Cadastros</div>
                              <div class="text_25 text_cinza text-center text_bold">{{user.qtd_convidado_novo_ultimo_mes}}</div>
                            </div>
                            <div class="col-8">
                              <div class="text_10 text_cinza">Ganhos</div>
                              <div class="text_25 text_cinza text_bold text_verde">R$ {{user.ganho_convidado_ultimo_mes}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                  </div>

                  <div class="col-md-4">
                      <div class="card">
                      <div class="card-body">
                        <div class="text_branco text_12 text_bold text-center pb-3">Últimos 7 Dias:</div>
                        <div class="col-12">
                          <div class="row">
                            <div class="col-4">
                              <div class="text_10 text_cinza text-center">Cadastros</div>
                              <div class="text_25 text_cinza text-center text_bold">{{user.qtd_convidado_novo_ultimo_mes}}</div>
                            </div>
                            <div class="col-8">
                              <div class="text_10 text_cinza">Ganhos</div>
                              <div class="text_25 text_cinza text_bold text_verde">R$ {{user.ganho_convidado_ultimo_mes}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                  </div>

                  <div class="col-md-4">
                      <div class="card">
                      <div class="card-body">
                        <div class="text_branco text_12 text_bold text-center pb-3">Mês passado:</div>
                        <div class="col-12">
                          <div class="row">
                            <div class="col-4">
                              <div class="text_10 text_cinza text-center">Cadastros</div>
                              <div class="text_25 text_cinza text-center text_bold">{{user.qtd_convidado_novo_ultimo_mes}}</div>
                            </div>
                            <div class="col-8">
                              <div class="text_10 text_cinza">Ganhos</div>
                              <div class="text_25 text_cinza text_bold text_verde">R$ {{user.ganho_convidado_ultimo_mes}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                  </div>


                </div>

          </div>
          <!-- fim coluna 10 -->

      </div>
      <!-- fim row -->

    </div>
    </div>
    </div>

    <ccFooter></ccFooter>

</div>
</template>

<script>

import axios from 'axios';
import {TheMask} from 'vue-the-mask'
import ccMenu from '../layout/menu.vue'
import  ccMenuConta from '../conta/menu_conta.vue'
import ccContaTopo from '../conta/topo.vue'
import ccContaConviteTopo from '../conta/convite_topo.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'CONVIDADOS',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],
      link_convite: null,
    }
  },

  components: {ccMenu, TheMask, ccContaTopo, ccContaConviteTopo, ccLoading, ccMenuConta, ccFooter},

  created()
  {
    document.title = 'Minha Conta: Convite Resumo - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} }
    else{ this.user = a }

    this.get_user_completo()
  },

  methods: {

    get_user_completo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'user/completo', header)
      .then(response => {

        this.user = response.data.resp

        this.link_convite = this.base_url_api+'/'+this.user.link_convite

        //set o local storage ------
        this.set_local_storate(this.user.balance, this.user.balance_convidado)

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
        this.expluse_para_login()
      });
    },

  }

}
</script>

<style scoped>
  .card{
    background: #FFFFFF08 0% 0% no-repeat padding-box;
    color:#fff;
  }
</style>


// WEBPACK FOOTER //
// src/components/conta/convite_resumo.vue